<template>
  <div>
    <integratedSearchBar
      button_type="contact_type_new_contact"
      :contactType.sync="contactType"
      v-bind:search.sync="search"
      search_label="Search contacts..."
    />

    <v-data-table
      :headers="headers"
      :items="fetchContacts"
      :search="search"
      :pagination.sync="pagination"
      rows-per-page-text="Contacts per page"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.first_name }}</td>
        <td>{{ props.item.last_name }}</td>
        <td>{{ props.item.username }}</td>
        <td>
          <div v-for="obj in props.item.phones">
            <a
              v-if="obj.key == 'Mobile' || obj.key == 'Whatsapp'"
              target="_blank"
              :href="'https://api.whatsapp.com/send?phone=' + obj.value"
            >
              {{ obj.key }}: {{ obj.value }}
            </a>
            <a v-else :href="'tel:' + obj.value">
              {{ obj.key }}: {{ obj.value }}
            </a>
          </div>
        </td>
        <td>
          <div v-for="obj in props.item.emails">
            <a :href="'mailto:' + obj.value"> {{ obj.key }}: {{ obj.value }}</a>
          </div>
        </td>
        <td>
          <div v-for="obj in props.item.skypes">
            <a :href="'skype:' + obj.value + '?call'">
              {{ obj.key }}: {{ obj.value }}</a
            >
          </div>
        </td>
        <td>
          <v-layout row align-center justify-end>
            <companyContactForm
              :contactType="contactType"
              showContact
              :companyContactId="props.item.id"
            />

            <v-btn
              id="goto_commercial_zones"
              flat
              round
              small
              v-if="contactType === 'commercial'"
              color="primary"
              :to="{ name: 'commercialZones', params: { id: props.item.id } }"
            >
              <v-icon small class="pr-2">public</v-icon>Zones</v-btn
            >

            <destroyModale
              resourceName="company_contact"
              :itemId="props.item.id"
              :icon="true"
              color="error"
              warningText="You are going to remove this contact and its associated resources permanently."
              :fab="false"
              :small="true"
              :small_icon="true"
            />
          </v-layout>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert
      >
    </v-data-table>

    <v-textarea
      auto-grow
      flat
      label=""
      class="ma-4"
      @change="
        updateModel(
          'companyStore',
          'newCompany',
          contactType + '_contacts_notes',
          $event
        )
      "
      :value="newCompany[contactType + '_contacts_notes']"
    >
      <template slot="label">
        <v-icon small class="pr-2">notes</v-icon>Notes
      </template>
    </v-textarea>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import companyContactForm from "./companyContactForm.vue";
import icons from "../../mixins/icons.js";
import card from "../shared/card";
import integratedSearchBar from "../shared/integratedSearchBar";

export default {
  mixins: [icons],
  components: {
    card,
    integratedSearchBar,
    companyContactForm,
  },
  props: {
    contactType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: "last_name",
      },
      headers: [
        {
          text: "First name",
          align: "left",
          sortable: true,
          value: "first_name",
        },
        {
          text: "Last name",
          align: "left",
          sortable: true,
          value: "last_name",
        },
        {
          text: "Username",
          align: "left",
          sortable: true,
          value: "username",
        },
        {
          text: "Phone",
          align: "left",
          sortable: false,
          value: "",
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "",
        },
        {
          text: "Skype",
          align: "left",
          sortable: false,
          value: "",
        },
        {
          text: "Actions",
          align: "right",
          value: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("companyStore", [
      "newCompany",
      "commercialContacts",
      "logisticContacts",
      "executiveContacts",
    ]),
    fetchContacts() {
      const type = this.contactType.split("_")[0];
      return this[`${type}Contacts`];
    },
  },
};
</script>
<style lang="stylus" scoped>
.search-field {
  max-width: 200px;
}
</style>
